import HttpClient from "@/api/utils/HttpClient"

export const edgeConfigClient = HttpClient({
  baseURL: "/api/edge-config",
  headers: {
    "Content-Type": "application/json",
  },
})
